import React, { useState, useEffect } from "react";
import {
    Container, Row, Col, Form, Button, Card, InputGroup, Spinner
} from "react-bootstrap";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import logo from "../Images/AZ.png";

function LoginPage() {
    const [credentials, setCredentials] = useState({ user_name: "", password: "" });
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => setInitialLoading(false), 2000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const res = await axios.get("https://www.azzenterprises.com/api/admin/getuser", { withCredentials: true });
                if (res.data.user_name) navigate("/customers");
            } catch { }
        };
        checkAuth();
    }, [navigate]);

    const togglePasswordVisibility = () => setShowPassword(!showPassword);
    const handleChange = (e) => setCredentials({ ...credentials, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post(
                "https://www.azzenterprises.com/api/admin/login",
                credentials,
                { withCredentials: true }
            );
            const user = response.data?.user;

            if (user?.status === "inactive") {
                toast.error("Your account is inactive. Contact admin.");
                setLoading(false);
                return;
            }

            toast.success("Login successful!");
            localStorage.setItem("user_name", user?.user_name || credentials.user_name);
            localStorage.setItem("user_role", user?.user_role || "user");

            setTimeout(() => {
                setLoading(false);
                navigate("/customers");
            }, 2000);
        } catch (error) {
            toast.error(error.response?.data?.message || "Invalid username or password.");
            setLoading(false);
        }
    };

    if (initialLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center min-vh-100 bg-gradient">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-gradient d-flex align-items-center justify-content-center min-vh-100" style={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" }}>
            <Container>
                <Row className="justify-content-center">
                    <Col xs={12} sm={10} md={6} lg={4}>
                        <Card className="p-0 shadow-lg border-0 rounded-4 overflow-hidden">
                            {/* Header */}
                            <div className="text-center bg-white p-4 position-relative">
                                <img src={logo} alt="Logo" className="img-fluid mb-2" style={{ maxWidth: "60px" }} />
                                <h4 className="fw-bold text-primary mb-1">AZZ ENTERPRISES PTE LTD</h4>
                                <p className="text-muted small fst-italic mb-0">
                                    🔒 Secured login. Your data is safe with us.
                                </p>
                            </div>

                            {/* Form */}
                            <Card.Body className="p-4">
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">Username</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="user_name"
                                            value={credentials.user_name}
                                            onChange={handleChange}
                                            placeholder="Enter username"
                                            required
                                            className="py-2"
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-semibold">Password</Form.Label>
                                        <InputGroup>
                                            <Form.Control
                                                type={showPassword ? "text" : "password"}
                                                name="password"
                                                value={credentials.password}
                                                onChange={handleChange}
                                                placeholder="••••••••"
                                                required
                                                className="py-2"
                                            />
                                            <InputGroup.Text
                                                as="button"
                                                type="button"
                                                onClick={togglePasswordVisibility}
                                                className="bg-white border-start-0"
                                                style={{ cursor: "pointer" }}
                                            >
                                                <i className={`bi bi-eye${showPassword ? "-slash" : ""}`}></i>
                                            </InputGroup.Text>
                                        </InputGroup>
                                    </Form.Group>

                                    <Form.Check
                                        type="checkbox"
                                        id="rememberMe"
                                        label="Remember me"
                                        className="mb-3"
                                        checked={rememberMe}
                                        onChange={(e) => setRememberMe(e.target.checked)}
                                    />

                                    <Button
                                        type="submit"
                                        className="w-100 py-2 fw-bold rounded-pill text-white"
                                        style={{
                                            background: "linear-gradient(90deg, #667eea, #764ba2)",
                                            border: "none",
                                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                            transition: "all 0.3s",
                                        }}
                                        disabled={loading}
                                    >
                                        {loading ? <Spinner animation="border" size="sm" className="me-2" /> : null}
                                        {loading ? "Logging in..." : "Login"}
                                    </Button>
                                </Form>
                            </Card.Body>

                            <Card.Footer className="bg-light text-center py-3">
                                <small className="text-muted">© 2025 AZZ ENTERPRISES PTE LTD. All rights reserved.</small>
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <ToastContainer
                position="top-right"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
}

export default LoginPage;